import { render, staticRenderFns } from "./hangYeZhanBi.vue?vue&type=template&id=238d1e66&scoped=true&"
import script from "./hangYeZhanBi.vue?vue&type=script&lang=js&"
export * from "./hangYeZhanBi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d1e66",
  null
  
)

export default component.exports